import React, { useState} from 'react'
import PulseLoader from "react-spinners/PulseLoader";
import {  useGenerateTrinityActionsForNoteMutation } from "@/features/userConversations/userConversationsApiSlice"

const EtTrinityConversationActionsCompanion = ({
    conversationId="",
    noteId="",
    userId="",
    userOrgId="",
}) => {

    // First Created - 08 Jun 2025
    // Author - Atul Pandey
    // Updated - 09 Jun 2025 - Added the main logic

    // 1 - State setup
    const [generatedActions, setGeneratedActions] = useState([]);
    
    // 2 - RTK Mutation for generate Action
    const [generateActions, { isLoading: isGenerating, error }] = useGenerateTrinityActionsForNoteMutation();

    // 3 - Handle Generate Actions
    const handleGenerateActions = async () => {
        setGeneratedActions([]);
        try {
            const result = await generateActions({
            conversationId,
            noteId,
            userId,
            userOrgId,
            }).unwrap();

            setGeneratedActions(result.createdActions || []);
        } catch (err) {
            console.error('Error generating actions:', err);
        }
    };

  return (
    <div className="p-2 m-2 bg-orange-50 rounded text-sm">

        {/* Step 4 - Generate Button */}
        <button
        onClick={handleGenerateActions}
        disabled={isGenerating}
        className="bg-orange-500 text-white px-3 py-1 rounded shadow hover:bg-orange-600 text-xs"
        >
        {isGenerating ? 'Generating...' : 'Generate Trinity Actions'}
        </button>

        {/* Step 4 - Loader */}
        {isGenerating && (
        <div className="mt-2 flex justify-start items-center">
            <PulseLoader size={6} color="#ea580c" />
            <span className="ml-2 text-xs text-orange-500">Thinking...</span>
        </div>
        )}

        {/* Step 4 - Error */}
        {error && (
        <div className="text-red-500 text-xs mt-2">⚠️ {error.message || 'Something went wrong'}</div>
        )}

        {/* Step 4 - Render Actions */}
        {generatedActions?.length > 0 && (
        <ul className="list-disc list-inside mt-2 text-xs text-gray-700">
            {generatedActions.map((a, idx) => (
            <li key={idx}>{a.name}</li>
            ))}
        </ul>
        )}
    </div>
  );

}

export default EtTrinityConversationActionsCompanion